// extracted by mini-css-extract-plugin
export default {"gray-20":"rgb(221, 224, 230)","container":"styles_container__82jyK","text":"styles_text__0Vxor"};